<section class="order-management">
  <div class="row">
    <div class="col-md-12">
      <app-breadcrumb [title3]="'ORDERMANAGEMENT.MANAGEORDERS.title'">
      </app-breadcrumb>
    </div>
    <div class="col-md-12">
      <div class="common-tabbing manage-order-tab">
        <mat-tab-group animationDuration="0ms" (click)="tabChangedClick($event)"
          (selectedTabChange)="tabChanged($event)" #tabGroup [selectedIndex]="selectedTab">
          <mat-tab *ngFor="let tabInfo of manageOrderTabbing" class="mt-5" label="{{tabInfo.label}}"
            aria-label="{{tabInfo.indexNumber}}">
            <ng-template mat-tab-label>
              {{tabInfo.label | translate}} <span class="count-label">{{tabInfo.count ? tabInfo.count : '0'}}</span>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
        <div class="table-content box-style company-info">
          <div class="table-heading">
            <h3 style="font-weight: 600">{{'ORDERMANAGEMENT.MANAGEORDERS.title' | translate}}
              <span (click)="onRefreshTable()" class="refresh-btn"
                matTooltip="Refresh"><mat-icon>autorenew</mat-icon></span>
            </h3>
            <div class="search-form-wrapper">
              <div class="search-form">
                <mat-icon matPrefix class="material-icons search">search</mat-icon>
                <input (keyup)="onKeyUp($event)" #searchBox [(ngModel)]="search" mat-input
                  placeholder="{{'ORDERMANAGEMENT.SEARCH'| translate}}" />
                <mat-icon *ngIf="this.search !== ''" class="material-icons clear"
                  (click)="resetSearch()">clear</mat-icon>
              </div>
              <button (click)="removeCataLog()" class="btn-style" routerLink="add-edit-order">
                <span class="material-icons">add</span>{{'ORDERMANAGEMENT.MANAGEORDERS.AddOrder' | translate}}
              </button>
              <button [matMenuTriggerFor]="menu" class="btn-style menu-btn">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="deleteMultipleIds()">
                  <span>{{'OTHERS.Delete' | translate}}</span>
                </button>
              </mat-menu>
            </div>
          </div>
          <div class="table-wrapper resource-color-table">
            <table #table
              [dataSource]="manageOrderData | paginate: {itemsPerPage: this.itemsPerPage, currentPage: this.page, totalItems: this.totalItems}"
              mat-table style="width: 100%">
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="remember-forgot" style="width: 80px;">
                  <mat-checkbox (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="remember-forgot" style="width: 80px;">
                  <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection?.isSelected(row)">
                  </mat-checkbox>
                </td>
              </ng-container>

              <ng-container matColumnDef="wheelAction">
                <th mat-header-cell *matHeaderCellDef style="width: 100px;">
                </th>
                <td mat-cell *matCellDef="let element; let i = index" style="width: 100px;">
                  <app-wheel-action [icons]="'two'" [editOn]="true" [deleteOn]="true" [element]="element"
                    (edit)="editOrder($event)" (delete)="deleteSingleOrder(element._id)"></app-wheel-action>
                </td>
              </ng-container>

              <ng-container matColumnDef="proposalId">
                <th (click)="changeSorting('_id',sortBy)" *matHeaderCellDef class="short-arrow" mat-header-cell>
                  {{'ORDERMANAGEMENT.MANAGEORDERS.OrderId' | translate}} <span
                    [ngClass]="{'down': sortKey === '_id' && sortBy === '-1', 'up': sortKey === '_id' && sortBy === '1'}">
                    <img alt="" src="assets/images/up-arrow.svg"></span> </th>
                <td mat-cell *matCellDef="let element" style="white-space: break-spaces;text-transform:capitalize;">{{
                  element.proposalId ? element.proposalId : '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="orderTitle">
                <th (click)="changeSorting('orderName',sortBy)" *matHeaderCellDef class="short-arrow" mat-header-cell>
                  {{'ExecuteOrder.ManageProposal.subject' | translate}} <span
                    [ngClass]="{'down': sortKey === 'orderName' && sortBy === '-1', 'up': sortKey === 'orderName' && sortBy === '1'}">
                    <img alt="" src="assets/images/up-arrow.svg"></span> </th>
                <td mat-cell *matCellDef="let element" style="white-space: break-spaces;text-transform:capitalize;">{{
                  element.orderName ? element.orderName : '-' }}</td>
              </ng-container>

              <!-- <ng-container matColumnDef="companyName">
                <th (click)="changeSorting('companyName',sortBy)" *matHeaderCellDef class="short-arrow" mat-header-cell>
                  {{'ORDERMANAGEMENT.MANAGEORDERS.CompanyName' | translate}} <span
                    [ngClass]="{'down': sortKey === 'companyName' && sortBy === '-1', 'up': sortKey === 'companyName' && sortBy === '1'}">
                    <img alt="" src="assets/images/up-arrow.svg"></span> </th>
                <td mat-cell *matCellDef="let element" style="white-space: break-spaces;text-transform:capitalize;">{{
                  element.companyName ? element.companyName : '-' }}</td>
              </ng-container> -->
              <ng-container matColumnDef="details">
                <th mat-header-cell *matHeaderCellDef style="width: 100px;">
                  {{'TABLE.ViewDetails' | translate}}
                </th>
                <td mat-cell *matCellDef="let element; let i = index" style="width: 100px;">
                  <button class="btn-style table-btn theme-line-btn sm-btn" (click)="viewOrderDetail(element)">
                    {{'TABLE.ViewDetails' | translate}}
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="createdAt">
                <th (click)="changeSorting('createdAt',sortBy)" *matHeaderCellDef class="short-arrow" mat-header-cell>
                  {{'ORDERMANAGEMENT.MANAGEORDERS.CreatedDate' | translate}} <span
                    [ngClass]="{'down': sortKey === 'createdAt' && sortBy === '-1', 'up': sortKey === 'createdAt' && sortBy === '1'}">
                    <img alt="" src="assets/images/up-arrow.svg"></span>
                </th>
                <td mat-cell *matCellDef="let element" style="white-space: break-spaces;text-transform: capitalize;">{{
                  (element.createdAt | date : 'dd/MM/yyyy HH:mm') ? (element.createdAt | date : 'dd/MM/yyyy HH:mm') :
                  '-'}}</td>
              </ng-container>

              <ng-container matColumnDef="statusReason">
                <th mat-header-cell *matHeaderCellDef style="width: 100px;">
                  {{'ORDERMANAGEMENT.MANAGEORDERS.StatusReason' | translate}}
                </th>
                <td mat-cell *matCellDef="let element" style="white-space: break-spaces;text-transform:capitalize;">
                  <span class="btn-style invited label-btn sm-btn table-btn"
                    *ngIf="element.customerStatus === orderStatusApproveRejet.pending">
                    {{'ExecuteOrder.ManageProposal.Open' | translate}}
                  </span>
                  <span class="active btn-style label-btn sm-btn table-btn"
                    *ngIf="element.customerStatus === orderStatusApproveRejet.approved">
                    {{'ExecuteOrder.ManageProposal.Accepted' | translate}}
                  </span>
                  <span class="btn-style declined label-btn sm-btn table-btn"
                    *ngIf="element.customerStatus === orderStatusApproveRejet.reject">
                    {{'ExecuteOrder.ManageProposal.Rejected' | translate}}
                  </span>
                  <span class="btn-style invited label-btn sm-btn table-btn"
                    *ngIf="element.customerStatus === orderStatusApproveRejet.IN_PROGRESS">
                    {{'ExecuteOrder.ManageProposal.In progress' | translate}}
                  </span>
                  <span class="active btn-style label-btn sm-btn table-btn"
                    *ngIf="element.customerStatus === orderStatusApproveRejet.REVIEW_OFFER">
                    {{'ExecuteOrder.ManageProposal.Proposal' | translate}}
                  </span>
                  <span class="active btn-style label-btn sm-btn table-btn"
                    *ngIf="element.customerStatus === orderStatusApproveRejet.IN_REVIEW">
                    {{'ExecuteOrder.ManageProposal.In progress' | translate}}
                  </span>
                  <span class="btn-style declined label-btn sm-btn table-btn"
                    *ngIf="element.customerStatus === orderStatusApproveRejet.REFUSED">
                    {{'ExecuteOrder.ManageProposal.Refused' | translate}}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef style="width: 100px;">
                  {{'TABLE.Action' | translate}}
                </th>
                <td mat-cell *matCellDef="let element; let i = index" style="width: 100px;">
                  <!-- *ngIf="element.status === orderStatusApproveRejet.IN_REVIEW" -->
                  <div *ngIf="element.customerStatus === orderStatusApproveRejet.REVIEW_OFFER" class="actions-btn">
                    <span title="{{'ORDERMANAGEMENT.ViewProposal'| translate}}" class="pdfdownload"
                      (click)="viewPDF(element.fileName)">
                      <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                        <path
                          d="M319-250h322v-60H319v60Zm0-170h322v-60H319v60ZM220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm331-554v-186H220v680h520v-494H551ZM220-820v186-186 680-680Z"
                          fill="#fff"></path>
                      </svg>
                    </span>
                    <button (click)="changeStatusApprove(element,element._id)"
                      class="btn-style table-btn green-btn sm-btn" style="min-width:80px;">
                      {{'ORDERMANAGEMENT.MANAGEORDERS.Approve' | translate}}
                    </button>

                    <button (click)="changeStatusReject(element,element._id)" class="btn-style table-btn red-btn sm-btn"
                      style="min-width:80px;">
                      {{'ORDERMANAGEMENT.MANAGEORDERS.Reject' | translate}}
                    </button>
                  </div>

                  <div
                    *ngIf="element.customerStatus === orderStatusApproveRejet.approved || element.status === orderStatusApproveRejet.REFUSED"
                    class="actions-btn">
                    <span title="{{'ORDERMANAGEMENT.ViewProposal'| translate}}" class="pdfdownload"
                      (click)="viewPDF(element.fileName)">
                      <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                        <path
                          d="M319-250h322v-60H319v60Zm0-170h322v-60H319v60ZM220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm331-554v-186H220v680h520v-494H551ZM220-820v186-186 680-680Z"
                          fill="#fff"></path>
                      </svg>
                    </span>
                    
                  </div>

                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="documentDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let element; columns: documentDisplayedColumns"></tr>
            </table>
          </div>
          <app-pagination [noRecordFound]="noRecordFound" [itemsPerPage]="itemsPerPage" [page]="page"
            (pageChange)="pageChanged($event)" (changeItem)="changeItemsPerPage($event)"
            [totalItems]="totalItems"></app-pagination>
        </div>

      </div>
    </div>

  </div>
</section>